<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">

  <div
    class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">

    <div class="shrink-0 flex flex-row items-center justify-start gap-x-4 sm:gap-x-6">
      <button (click)="exit()" type="button" class="btn-shout btn-shout-fab-secondary" aria-label="Go back">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
          <path d="m12 19-7-7 7-7" />
          <path d="M19 12H5" />
        </svg>
      </button>

      <div>
        <h3 class="text-md font-semibold text-primary">Create Monitoring Brief</h3>
        <p class="mt-0 text-xs text-secondary">{{ monitoringTypeLabel() }}</p>
      </div>
    </div>

    <div class="flex flex-row items-center justify-end gap-x-4">
      @if (screen() !== 'chooser') {
      <button type="button" class="btn-shout btn-shout-sm btn-shout-secondary shrink-0" (click)="switchFlow()">Switch flow</button>
      }
    </div>

  </div>

  <div class="h-full flex-1 flex-col items-center justify-center w-full overflow-hidden">
    @switch (screen()) {
    @case ('chooser') {
    <cmb-flow-chooser (choose)="chooseFlow($event)" />
    }
    @case ('wizard') {
    <cmb-wizard-first (launch)="submit()" />
    }
    @case ('ai') {
    <cmb-ai-first (launch)="submit()" (startOver)="startOver()" />
    }
    }
  </div>

</div>

@if (submitStage() !== 'idle') {
<sbs-screening-overlay [stages]="submitStages" headIcon="send" headline="Submitting Brief" subLead="Sending"
  [subject]="briefName()" subTrail="to the SHOUT monitoring engine…" [result]="overlayResult()" passIcon="check-check"
  resultTitle="Brief Submitted." [resultSub]="briefName() + ' ' + submittedSub()">

  <div overlayActions class="contents">
    <button type="button" class="btn-shout btn-shout-md btn-shout-primary shrink-0" (click)="openManageBrief()">
      View brief
    </button>
    <button type="button" class="btn-shout btn-shout-md btn-shout-secondary shrink-0" (click)="goHome()">
      Close
    </button>
  </div>
</sbs-screening-overlay>
}
